import * as React from 'react';

const DEFAULT_PIXELS_PER_MINUTE = 1;

const PixelsPerMinuteRatioContext = React.createContext<number>(DEFAULT_PIXELS_PER_MINUTE);
PixelsPerMinuteRatioContext.displayName = 'PixelsPerMinuteRatioContext';

/**
 * Provider for consumers to specify the pixels per minute of a week view grid to downstream consumers
 */
export const PixelsPerMinuteRatioProvider = PixelsPerMinuteRatioContext.Provider;

/**
 * Hook that returns the pixels per minute factor of a rendered grid
 */
export function usePixelsPerMinuteRatio() {
    const contextualValue = React.useContext(PixelsPerMinuteRatioContext);
    return contextualValue || DEFAULT_PIXELS_PER_MINUTE;
}
